import { StepAI_Members } from '../masterclass/ai/StepAI_Members';

// Reuse the existing Members step until the mentorship-specific UI is defined
export function MentorshipMembers() {
  return <StepAI_Members />;
}

export default MentorshipMembers;
